/* assets/src/viewer/util.js — helper colore/dati (port :283-312). */

export function hexToRgb(hex) {
  const value = String(hex || '').replace('#', '');
  const normalized = value.length === 3 ? value.split('').map((ch) => ch + ch).join('') : value;
  const intVal = parseInt(normalized, 16);
  return {
    r: (intVal >> 16) & 255,
    g: (intVal >> 8) & 255,
    b: intVal & 255,
  };
}

export function rgbToCss({ r, g, b }) {
  const c = (v) => Math.max(0, Math.min(255, Math.round(v)));
  return `rgb(${c(r)}, ${c(g)}, ${c(b)})`;
}

export function tintRgb(rgb, amount = 0) {
  return {
    r: rgb.r + (255 - rgb.r) * amount,
    g: rgb.g + (255 - rgb.g) * amount,
    b: rgb.b + (255 - rgb.b) * amount,
  };
}

export function shadeRgb(rgb, amount = 0) {
  return {
    r: rgb.r * (1 - amount),
    g: rgb.g * (1 - amount),
    b: rgb.b * (1 - amount),
  };
}

// Normalizza un valore colore di config (hex, 'base', 'ral', 'soltis', ecc.) in un intero 0xRRGGBB.
export function parseStructureColor(value) {
  if (value === 'ral' || !value || value === 'base') return 0x6c6e70;
  if (typeof value === 'string' && value.charAt(0) === '#') return parseInt(value.replace('#', '0x'), 16) >>> 0;
  if (typeof value === 'string' && /^[0-9a-f]{6}$/i.test(value)) return parseInt(value, 16) >>> 0;
  return 0x6c6e70;
}

export function parseFabricColor(value) {
  if (value === 'other' || value === 'base' || !value) return 0xcbd5e1;
  if (value === 'soltis') return 0xe2e8f0;
  if (typeof value === 'string' && value.charAt(0) === '#') return parseInt(value.replace('#', '0x'), 16) >>> 0;
  if (typeof value === 'string' && /^[0-9a-f]{6}$/i.test(value)) return parseInt(value, 16) >>> 0;
  return 0xa7a9ab;
}
